import { Season } from '../../domain/models/season.model';
import {
  RetrieveSeasons,
  RetrieveSeasonsFailure,
  RetrieveSeasonsPayload,
  RetrieveSeasonsSuccess,
  RETRIEVE_SEASONS,
  RETRIEVE_SEASONS_FAILURE,
  RETRIEVE_SEASONS_SUCCESS,
} from './season.action.type';

export const retrieveSeasons = (
  payload: RetrieveSeasonsPayload,
): RetrieveSeasons => ({
  type: RETRIEVE_SEASONS,
  payload,
});

export const retrieveSeasonsSuccess = (
  payload: Season[],
): RetrieveSeasonsSuccess => ({
  type: RETRIEVE_SEASONS_SUCCESS,
  payload,
});

export const retrieveSeasonsFailure = (
  error: string,
): RetrieveSeasonsFailure => ({
  type: RETRIEVE_SEASONS_FAILURE,
  payload: error,
});
